import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getIntegrationsHostConfig } from "../../config/integrationsHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";
import { usePermissionState } from "../../contexts/PermissionStateContext";

export const Route = createFileRoute("/integrations/$")({
  component: IntegrationsCatchAll,
});

function IntegrationsCatchAll() {
  const onNavigate = useHostNavigate();
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="integrations"
      props={{
        hostConfig: getIntegrationsHostConfig(onNavigate, permissionState),
      }}
    />
  );
}
